<script>
	import { navigate } from 'svelte-routing';
	import LegacyComponentWrapper from '../../frame-components/legacy-component-wrapper.svelte';
	import { active_breadcrumb, show_header, show_sidebar } from '../../app-store'

	export let params;

	let legacy_component ={
		id: "article-list-loader",
		screen_container_el: null,
		_create_error_alert_el: function (message) {
			return tag.article(
				{ class: "alert alert-danger project-item animate-in" },
				tag.div({ class: "project-item-body" }, [
					tag.div({ class: "alert-title fw-bold"}, "Error"),
					tag.div({ class: "alert-message" }, message),
					tag.div({ class: "d-flex gap-1"}, [
						tag.button({type: "button", class: "btn btn-primary", onclick: ()=> window.location.reload()}, "Retry")
					])
				])
			);
		},
		show: function () {
			document.getElementById(this.id).classList.remove("hidden");
		},
		hide: function () {
			document.getElementById(this.id).classList.add("hidden");
		},
		onshow : async function (payload = {}) {
			payload = payload || {};
			const project_ref = params.project_ref;
			const refcode = params.draft_refcode;
			const keyphrase_url_tuple = payload.keyphrase_url_tuple || [];
			const competitor_urls = payload.competitor_urls || [];
			const creds = app.storage.get("creds");

			app.body_spinner.remove();
			app.chat_manager.show();
			app.chat_manager.clear();
			app.chat_manager.send_ai_message("researcher", "fill_complete", { email: creds.email });

			const get_article_url_host = (article_url) => {
				try {
					return new URL(article_url).hostname
				} catch (error) {
					return article_url;
				}
			}

			const article_container_el = tag.div({ class: "article-preview-container" });
			const article_preview_item_el = ({ id, title, url, description }) => {
				return tag.div(
					{ class: "preview-item", "data-article_id": id },
					tag.div(
						{ class: "preview-item-image-wrapper" },
						tag.img({
							src: "",
							alt: "Loading...",
							class: "preview-item-image loading",
							width: "531",
							height: "184",
						}),
						tag.div({ class: "preview-item-image-loader" })
					),
					tag.div(
						{ class: "preview-item-title-container" },
						tag.h3({ class: "preview-item-title" }, title),
						tag.p({ class: "preview-item-domain" }, get_article_url_host(url))
					),
					tag.img({ src: "./img/search-2-line.svg", width: "75", height: "75", class: "search-icon" })
				);
			};

			// Prepare the container
			const preview_item_els = [];
			const max_skeletons = 60;
			const carousel_container_el = tag.div({ class: "embla" });
			const article_list_el = tag.div({ class: "article-list embla__container" });

			for (let i = 0; i < max_skeletons; i++) {
				const embale__slide_el = tag.div({ class: "embla__slide " });
				const skeleton_el = tag.div({ class: "preview-item skeleton" });
				embale__slide_el.appendChild(skeleton_el);
				article_list_el.appendChild(embale__slide_el);
				preview_item_els.push(skeleton_el);
			}
			carousel_container_el.appendChild(article_list_el);
			article_container_el.appendChild(carousel_container_el);

			const embla_carousel = window.EmblaCarousel(carousel_container_el, { loop: false });
			const status_msg_el = tag.div({ class: "preview-status-msg" });
			carousel_container_el.appendChild(status_msg_el);
			document.body.appendChild(article_container_el);

			status_msg_el.textContent = "Requesting for recommended sources..."

			article_container_el.addEventListener("research-keyword-content", (e) => {
				const keyword_ref = e.detail.keyword_ref;
				status_msg_el.textContent = "Analyzing keyword: " + keyword_ref;
			});

			article_container_el.addEventListener("research-web-content", (e) => {
				const url_ref = e.detail.url_ref;
				status_msg_el.textContent = "Analyzing content from: " + url_ref;
			})

			article_container_el.addEventListener("research-started", (e) => {
				app.chat_manager.send_ai_message("researcher", "researching");
				status_msg_el.textContent = "Starting Research...";
			});

			article_container_el.addEventListener("research-analysing", (e) => {
				app.chat_manager.send_ai_message("researcher", "analysing", { keyphrase: JSON.stringify(keyphrase_url_tuple) });
				status_msg_el.textContent = "Analysing Content...";
			});

			article_container_el.addEventListener("research-discovering", (e) => {
				app.chat_manager.send_ai_message("researcher", "discovering");
				status_msg_el.textContent = "Discovering...";
			});

			article_container_el.addEventListener("research-crawling", (e) => {
				const crawled_content = e.detail.crawled_content;
				status_msg_el.textContent = "";
				const articles = crawled_content.map((article, i) => {
					return {
						id: i,
						title: article.title,
						url: article.url,
						description: article.description,
					};
				});
				const max_time_s = articles.length * 1; // 1s per article
				let processed_article_index = 0;
				const timer = window.create_timer(max_time_s, {
					tick_interval: 2000,
					on_start: () => {
						status_msg_el.textContent = "";
					},
					on_tick: async (time) => {
						// Each tick, replace the skeleton with the actual article
						const article = articles[processed_article_index];
						processed_article_index++;
						if (!article) {
							return;
						}
						const article_el = article_preview_item_el({
							id: article.id,
							title: article.title,
							url: article.url,
							description: article.description,
						});
						const article_img_el = article_el.querySelector(".preview-item-image");
						const article_img_loader_el = article_el.querySelector(".preview-item-image-loader");
						try {
							const { previewimg } = await app.lucep_ai.get_url_previewimage(article.url);
							if (!previewimg) {
								article_img_el.classList.remove("loading");
								article_img_el.src = "./img/noimage.png";
								article_img_el.alt = "No image available";
								article_img_loader_el.remove();
								return;
							}
							article_img_el.src = previewimg;
							article_img_el.alt = "Article image for " + article.title;
							article_img_el.addEventListener("load", (e) => {
								article_img_el.classList.remove("loading");
								article_img_loader_el.remove();
								// Store the image in this var for later use
								app.cache_imgs[article.url] = previewimg;
							});
							article_el.addEventListener("error", (e) => {
								article_img_el.classList.remove("loading");
								article_img_el.src = "./img/noimage.png";
								article_img_el.alt = "No image available";
								article_img_loader_el.remove();
							});
						} catch (error) {
							console.error("Error fetching image:", error);
							app.toast_msg.show("Erorr fetching image from " + article.url)
							article_img_el.src = "./img/noimage.png";
							article_img_el.alt = "No image available";
						}
						// Move carousel to the current article id
						if (embla_carousel) {
							embla_carousel.scrollTo(processed_article_index);
						}
						// Replace the skeleton with the actual article
						if (preview_item_els[processed_article_index]) {
							preview_item_els[processed_article_index].replaceWith(article_el);
							// Also replace the skeleton in the array
							preview_item_els[processed_article_index] = article_el;
							const previous_article_el = preview_item_els[processed_article_index - 1];
							if (previous_article_el) {
								previous_article_el.classList.remove("active");
							}
							article_el.classList.add("active");
						}
						// If the article is the last item, just remove active class
						if (articles.length - 1 === processed_article_index) {
							article_el.classList.remove("active");
						}
					},
					on_complete: () => {
						// Do not do anything, just wait for the websocket
						// respond that the research has been completed
					},
				});

				timer.start();
			});

			article_container_el.addEventListener("research-finished", async (e) => {
				app.body_spinner.add_to(document.body);
				try {
					const refcode = e.detail.refcode;
					app.body_spinner.remove();
					active_breadcrumb.set("breadcrumb-recommended-sources");

					navigate(`/article-list/${project_ref}/${refcode}`);
				} catch (error) {
					let err_el;
					if (error.status_code === 500) {
						err_el = this._create_error_alert_el(error_msg.server_error(error.msg))
					} else {
						err_el = this._create_error_alert_el(error_msg.client_error(error.msg));
					}
					this.screen_container_el.innerHTML = "";
					this.screen_container_el.append(err_el);
				}
			});

			app.lucep_ai.research_draft(refcode, keyphrase_url_tuple, competitor_urls, {
				project_ref: project_ref,
				funnel_stage: 0,
				onUpdate: (data) => {
					switch (data.status) {
						case "start":
							const event_started = new CustomEvent("research-started");
							article_container_el.dispatchEvent(event_started);
							break;
						case "analysing":
							const event_analysing = new CustomEvent("research-analysing");
							article_container_el.dispatchEvent(event_analysing);
							break;
						case "discovering":
							const event_discovering = new CustomEvent("research-discovering");
							article_container_el.dispatchEvent(event_discovering);
							break;
						case "crawling":
							const event_crawling = new CustomEvent("research-crawling", {
								detail: { crawled_content: data.content },
							});
							article_container_el.dispatchEvent(event_crawling);
							break;
						case "keyword-content":
							const event_keyword_content = new CustomEvent("research-keyword-content", {
								detail: { keyword_ref: data["keyword-ref"] || "" },
							});
							article_container_el.dispatchEvent(event_keyword_content);
							break;
						case "web-content":
							const event_web_content = new CustomEvent("research-web-content", {
								detail: { url_ref: data["url-ref"] || "" }
							});
							article_container_el.dispatchEvent(event_web_content);
							break;
						default:
							console.warn(`Unhandled status: ${data.status}`, data);
					}
				},
				onFinished: (res) => {
					const evenet_finished = new CustomEvent("research-finished", { detail: { refcode: refcode } });
					article_container_el.dispatchEvent(evenet_finished);
				},
				onError: (res) => {
					this.screen_container_el.innerHTML = "";
					this.screen_container_el.append(this._create_error_alert_el(error_msg.server_error(res.message)));
				}
			}).catch((error) => {
				let err_el;
				if (error.status_code === 500) {
					err_el = this._create_error_alert_el(error_msg.server_error(error.msg))
				} else {
					err_el = this._create_error_alert_el(error_msg.client_error(error.msg));
				}
				this.screen_container_el.innerHTML = "";
				this.screen_container_el.append(err_el);
			})
			this.screen_container_el.innerHTML = "";
			this.screen_container_el.append(article_container_el);
		},
		init: function () {
			this.screen_container_el = tag.div({ class: "action-area action-area-article-loader" });
			return this.screen_container_el;
		},
	};

</script>

<LegacyComponentWrapper legacy_component={legacy_component} params={params} />
